import request from '@/utils/request'

export function getStorageList(data) {
  return request.post('/storage/list', data)
}

export function addStorage(data) {
  return request.post('/storage/add', data)
}

export function modifyStorage(data) {
  return request.post('/storage/modify', data)
}

export function deleteStorage(data) {
  return request.post('/storage/delete', data)
}

export function setStatusOfStorage(data) {
  return request.post('/storage/up-down-shelf', data)
}



// WEBPACK FOOTER //
// ./src/api/settings/storage.js